// extracted by mini-css-extract-plugin
export default {"textEditorWrapper":"styles__textEditorWrapper___CCAJP","characterCounter":"styles__characterCounter___W7Lje"};